import { createAction, props } from '@ngrx/store'
import { MenuItemsEntity } from './menu-items.models'
import { HttpErrorResponse } from '@angular/common/http'
import { Update } from '@ngrx/entity'

export const loadMenuItems = createAction('[MenuItems Page] Load Menu Items')

export const loadMenuItemsSuccess = createAction(
  '[MenuItems/API] Load MenuItems Success',
  props<{ menuItems: MenuItemsEntity[] }>(),
)

export const loadMenuItemsFailure = createAction(
  '[MenuItems/API] Load MenuItems Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const selectMenuItem = createAction('[MenuItems/API] Select Menu Item', props<{ uuid: string }>())

export const clearSelectMenuItem = createAction('[MenuItems/API] Clear Selected Menu Item')

export const deleteMenuItem = createAction(
  '[MenuItems/API] Delete Menu Item',
  props<{ uuid: string; shouldShowConfirmDialog?: boolean }>(),
)

export const deleteMenuItemSuccess = createAction('[MenuItems/API] Delete Menu Item Success', props<{ uuid: string }>())

export const deleteMenuItemFailure = createAction(
  '[MenuItems/API] Delete Menu Item Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openCreateMenuItemDialog = createAction('[MenuItems/API] Open Create Menu Item Dialog ')

export const createMenuItem = createAction(
  '[MenuItems/API] Create Menu Item',
  props<{
    menuItem: Partial<MenuItemsEntity>
    doNotShowSuccessToast?: boolean
  }>(),
)

export const createMenuItemSuccess = createAction(
  '[MenuItems/API] Create Menu Item Success',
  props<{
    menuItem: MenuItemsEntity
    doNotShowSuccessToast?: boolean
  }>(),
)

export const createMenuItemFailure = createAction(
  '[MenuItems/API] Create Menu Item Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateMenuItem = createAction(
  '[MenuItems/API] Update Menu Item',
  props<{ menuItem: Partial<MenuItemsEntity> }>(),
)

export const updateMenuItemSuccess = createAction(
  '[MenuItems/API] Update Menu Item Success',
  props<{ update: Update<MenuItemsEntity> }>(),
)

export const updateMenuItemFailure = createAction(
  '[MenuItems/API] Update Menu Item Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateMenuItemOrder = createAction(
  '[MenuItems/API] Update Menu Items Order',
  props<{ menuItemUuids: string[]; doNotShowLoader?: boolean }>(),
)

export const updateMenuItemOrderSuccess = createAction(
  '[MenuItems/API] Update Menu Items Order Success',
  props<{ menuItems: Update<MenuItemsEntity>[] }>(),
)

export const updateMenuItemOrderFailure = createAction(
  '[MenuItems/API] Update Menu Items Order Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const clearMenuItems = createAction('[MenuItems/Page] Clear Menu Items')

export const loadMenuItemResources = createAction('[MenuItems/API] Load Menu Item Resources')

export const loadMenuItemResourcesSuccess = createAction('[MenuItems/API] Load Menu Item Resources Success')

export const loadMenuItemResourcesFailure = createAction(
  '[MenuItems/API] Load Menu Item Resources Failure',
  props<{ error: any }>(),
)
